<template>
	<div id="indexpage" v-title :data-title="title" style="height:100%;">
		<!-- <headerbar msg="chanyednao" :curindex="false"> </headerbar> --> 
		  
		<leftnav mkcode="D" itemcode="D-CYFZ"  :smScrennFull="true"></leftnav>
			  
		<!-- 弹框 -->	
			
		<div class="por" style="background-color: #041034;height:100%;">
			<!-- 全屏开始 -->
			<i class="el-icon-full-screen swiper_fullscreen" @click="screen()"></i>
			<!-- 全屏结束 -->
			<div class="index-swiper centerpage"> 
				<daswiperNav :title="title" navcode="CYYD" :indexnum="9" :fulltitle="true"></daswiperNav>
				<div class="indexflex chanyeyongdi">
					<div class="col2h colbox hr500">
						<h3 class="cyyd_title">产业用地面积分布</h3>
						<div id="cyyd_echartmap"></div>
					</div>
					<div class="col5 colbox hr500">
						<h3 class="cyyd_title">各类型产业用地成交面积及金额</h3>
						<table border="0" cellspacing="0" cellpadding="0" class="cyyd_table1">
							<tr><th>用地类型</th><th>成交面积（亩）</th><th>成交金额（万元）</th></tr>
							<tr :key="index" v-for="(item,index) in landType"><td>{{item.name}}</td><td class="bdrl">{{item.size}}</td><td>{{item.money}}</td></tr> 
						</table> 
					</div>
					<div class="col2h colbox hr500">
						<h3 class="cyyd_title">2021年前十大行业用地面积</h3>
						<div id="cyyd_echartbar1"></div>
					</div>
					<div class="col2h colbox hr390">
						<h3 class="cyyd_title">产业用地成交均价分布</h3>
						<div id="cyyd_echartbar2"></div>
					</div>
					<div class="col5 colbox hr390">
						<h3 class="cyyd_title">工矿及商服用地面积走势</h3>
						<div id="cyyd_echartline1"></div> 
					</div>
					<div class="col2h colbox hr390">
						<h3 class="cyyd_title">2021年前十大行业用地金额</h3>
						<div id="cyyd_echartpie1"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template> 
<script>
	import mappng from '../../assets/images/mapbg.png';
	export default {
		name: 'chanyeyongdi',
		data() {
			return {
				isCollapse:false,
				isFullscreen: false,
				direction:"ltr",  //btt
				direction2:"btt",  //btt
				 drawer: false,
					drawer2: false,
					modal:false,
				title: "产业用地交易监测大屏",bgcolor:"#041034",
				usernotionlistsave: [],
				userdata: {},
				mapurl: 'map/city/321200.json',
				islogin: false,
				flag: true,
				swipernum: 3,
				listdata: [],
				public_tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					}
				},
				// mapurl: 'map/city/321200.json',
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				landType:[],
				startCharts: null,
				//假数据 
			}
		},
		props: {
			msg: String,
		},
		mounted() {
			document.getElementById('app').style.background=this.bgcolor;
		 this.getuserinfor(); 
			console.log(this.title,this.userdata); 
			// alert(this.userdata.token) 
		},
		methods: {
			//获取用户信息
			getuserinfor() {
				this.userdata = this.getuseriformation();
				if(this.userdata.token){
					this.mapurl =  'map/'+this.userdata.currentCity.type+'/'+this.userdata.currentCity.mapname+'.json';
					this.bus.$emit('loading', true);
					if(this.userdata.edition<1){
						var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
						setTimeout(function(){
							_this.routerself('/totalEnterprises');
						},1000)
						return;
					}
					this.getajasdata(); 
					}else{
					console.log('拿不到token值')
				}
				
			},
			getajasdata(){
				var _this=this,newdatasm=[],newsfdata=[];
				// this.bus.$emit('loading', true);
				
					this.$axios.get(this.$api.cyl.govsaaschart.industryland(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
						console.log(res.data.data);
						if(res.data.success){   
							_this.bus.$emit('loading', false);
							var datd=res.data.data; 
							_this.landType=datd.landType;
							_this.mapGeo('cyyd_echartmap',datd.areaSize); //产业用地面积分布
								_this.cyyddatabarfunb('cyyd_echartbar2',datd.avgPrice); //均价分布 
								_this.cyyd_echartpie1('cyyd_echartpie1',datd.landIndustry.money) //2021年前十大行业用地金额
								_this.cyyddatabarfuna('cyyd_echartbar1',datd.landIndustry.size); //2021年前十大行业用地面积 
								_this.cyyddatalinefun('cyyd_echartline1',datd.month_2016_2020);//2016-2020工矿商服用地面积走势 
								_this.bus.$emit('loading', false);
						}
					
					}).catch(function (error) { 
						// 请求失败处理 console.log(error);
						_this.bus.$emit('loading', false);
					}); 
				  
			}, 
			cyyd_echartpie1(el, data) { //2021年前十大行业用地金额 
				var charPie3currentIndex = 0, isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var Taxchart = echarts.init(document.getElementById('cyyd_echartpie1')); 
				var xdata=[],seriesdata=[];
				for(var i=0;i<data.length;i++){
					xdata.push(data[i].name);
					seriesdata.push(data[i].money);
				}
				var		option = {
				  title: {
				    text: '',
				  },
				  tooltip: {
				    show:true,
								trigger: 'axis'
				  },
				  legend: {
				    show:true,
								textStyle:{color:"#eee",fontSize:12,},
								icon:'rect',  //图例样式 圆点circle 矩形rect
								itemWidth:10,
								itemHeight:9, 
								right:'5%',
				  }, 
				  grid: {
				    left: '3%',
				    right: '4%',
								top:'5%',
				    bottom: '0%',
				    containLabel: true
				  },
				  xAxis: [
				    {
				      type: 'category',
				      boundaryGap: false,
										color:"#eee",
				      data:xdata,
										axisLine: {show:true,  lineStyle:{ color:'#eee', } }, 		//轴线
										axisTick:{show:false }, //刻度线
										axisLabel:{interval:0,rotate:40,fontSize: 9,color:'#eee'},
				    }
				  ],
				  yAxis: [
				    {
				      type: 'value', 
										min:0,				//最小值
										// max: 400,			//最大值
										// interval: 100,		//步长值
										splitLine:{show:false}, //不显示网格线
										axisLine: {show:false,  lineStyle:{ color:'#eee', } }, 		//轴线
				    }
				  ],
				  series: [
				    {
														name: '用地金额（万元）',
				          data: seriesdata,
				          type: 'line',
				          // smooth: true, //线条平滑 
														symbol:'circle', //拐点样式
														symbolSize: 5,//拐点大小
														color:'#5E83CC',
														areaStyle: {color:'rgba(0,176,255,.5)'},
														// stack: 'Total', //同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
				        }, 
				  ]
				};
				Taxchart.setOption(option); 
				var startCharts = null;
				// 2、鼠标移动上去的时候的高亮动画
				Taxchart.on('mouseover', function(param) {
					isSet = false
					clearInterval(startCharts)
					// 取消之前高亮的图形
					Taxchart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					// 高亮当前图形
					Taxchart.dispatchAction({
						type: 'highlight',
						seriesIndex: 0,
						dataIndex: param.dataIndex
					})
					// 显示 tooltip
					Taxchart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						dataIndex: param.dataIndex
					})
				});
				var chartHover = function() {
					var dataLen = option.series[0].data.length
					// 取消之前高亮的图形
					Taxchart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
					// 高亮当前图形
					Taxchart.dispatchAction({
						type: 'highlight',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					// 显示 tooltip
					Taxchart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
				}
				startCharts = setInterval(chartHover, 2000)
				// 4、鼠标移出之后，恢复自动高亮
				Taxchart.on('mouseout', function(param) {
					if (!isSet) {
						startCharts = setInterval(chartHover, 2000)
						isSet = true
					}
				});
			},
			mapGeo(el, data,scdata) {
				var myChart = echarts.init(document.getElementById(el));
				var mapUrl = this.mapurl;
				console.log('产业用地数据',data);
				var tootlips=this.public_tooltip; 
				$.getJSON(mapUrl, function(geoJson) {
					echarts.registerMap('taizhou', geoJson);
					myChart.hideLoading(); 
					var option = {
						backgroundColor: 'rgba(0,0,0,0)',
						title: {
							top: 20,
							text: '',
							subtext: '',
							x: 'center',
							textStyle: {
								color: '#fff',
								fontWeight: 100,
								fontSize: 14,
							},
						}, 
						tooltip:{
							alwaysShowContent: true,
							show: true,
							hoverAnimation: true,
							trigger: 'item', //触发类型 散点图
							enterable: true, //鼠标是否可进入提示框
							transitionDuration: 1, //提示框移动动画过渡时间
							triggerOn: 'click',
							borderWidth: '1px',
							borderRadius: '4',
							borderColor: '#00B2AC',
							backgroundColor: "rgba(0,0,0,.8)",
							textStyle: {
								color: '#fff'
							},
							formatter:function(parms){
								return "<h4 class='oh'><span class='fl'>地区</span><span class='fr'>"+parms.name+"</span></h4><div class='oh'><span class='fl'>产业用地（亩）</span><span class='fr'>"+parms.value+"</span></div>";
							}
						},
						geo: {
							map: 'taizhou',
							aspectScale:0.8,
							layoutCenter: ['50%', '50.5%'],
							layoutSize: '100%',
							silent: true,
							roam: false,
							z: 0,
							itemStyle: {
								normal: {
									areaColor: 'rgba(0,0,0,.5)',
									shadowColor: 'rgba(0, 0, 0, 1)',
									shadowBlur: 0,
									shadowOffsetX: 0,
									shadowOffsetY: 1,
									borderColor: 'rgba(0, 0, 0, 0.7)',
									borderWidth: 0.5,
								},
								emphasis: {
									areaColor: 'rgba(0,0,0,0)',
									borderWidth: 1,
									color: 'green',
									label: {
										show: true,
									},
								},
							},
						},
						series: [{
							type: 'map',
							zoom: 1.1,
							// roam: false,
							map: 'taizhou',
							roam: false,
							data:data,
							label: {
								normal: {
									show: true,
									textStyle: {
										color: '#fff',
									},
								},
								emphasis: {
									textStyle: {
										color: '#fff',
									},
								},
							},
							itemStyle: {
								normal: {
									borderColor: '#6185be',
									borderWidth: 1,
									// areaColor: {
									// 	image: mappng,
									// 	repeat: 'repeat',
									// },
									areaColor:"#045c99",
									shadowColor: '#96aece',
									shadowBlur: 0,
									shadowOffsetX: 0,
									shadowOffsetY: 1,
								},
								emphasis: {
									// areaColor: {
									// 	image: '#f60',
									// 	repeat: 'repeat',
									// },
									areaColor:"#023e64",
									borderColor: '#ccc',
									borderWidth: 1,
									shadowColor: '#96aece',
									shadowBlur: 10,
									shadowOffsetX: 2,
									shadowOffsetY: 1,
									label: {
										show: true,
									},
								},
							},
							
						},
						// {
						// 					type:"effectScatter",       //带有涟漪特效动画的散点（气泡）图。
						// 					data:scdata,
						// 					coordinateSystem:'geo',     //'geo',使用地理坐标系/ 该系列使用的坐标系，'cartesian2d',使用二维的直角坐标系/'polar'使用极坐标系，
						// 					rippleEffect:{              //涟漪特效相关配置。
						// 									scale:20,        // 波纹的最大缩放比例
						// 									color:'blue',        //涟漪颜色
						// 									period:2,       // 动画的周期，秒数
						// 									brushType:'stroke'      // 波纹样式：'stroke'  ，'fill'
						// 					}
						// 	} 
						],
					};
					myChart.setOption(option);
				});
				var hourIndex = 0;
				var fhourTime = null;
				fhourTime = setInterval(function() {
					myChart.dispatchAction({
						type: "downplay",
						seriesIndex: 0,

					});
					myChart.dispatchAction({
						type: "highlight",
						seriesIndex: 0,
						dataIndex: hourIndex
					});
					myChart.dispatchAction({
						type: "showTip",
						seriesIndex: 0,
						dataIndex: hourIndex
					});
					hourIndex++;
					if (hourIndex > data.length) {
						hourIndex = 0;
					}
				}, 3000);
				//鼠标移入停止轮播
				myChart.on("mousemove", function(e) {
					clearInterval(fhourTime)
					myChart.dispatchAction({
						type: "downplay",
						seriesIndex: 0,
					});
					myChart.dispatchAction({
						type: "highlight",
						seriesIndex: 0,
						dataIndex: e.dataIndex
					});
					myChart.dispatchAction({
						type: "showTip",
						seriesIndex: 0,
						dataIndex: e.dataIndex
					});
				})
				//鼠标移出恢复轮播
				myChart.on("mouseout", function() {
					fhourTime = setInterval(function() {
						myChart.dispatchAction({
							type: "downplay",
							seriesIndex: 0,

						});
						myChart.dispatchAction({
							type: "highlight",
							seriesIndex: 0,
							dataIndex: hourIndex
						});
						myChart.dispatchAction({
							type: "showTip",
							seriesIndex: 0,
							dataIndex: hourIndex
						});
						hourIndex++;
						if (hourIndex > data.length) {
							hourIndex = 0;
						}
					}, 3000);
				})
			},
			cyyddatabarfuna(el,data){  //2021年前十大行业用地面积 
			console.log(data);
				var chart = echarts.init(document.getElementById(el)); 
				var _this = this,xline=[],seriesline=[]; 
				var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消 
				for(var i=0;i<data.length;i++){
					xline.push(data[i].name);
					seriesline.push(data[i].size);
				}
				console.log(xline,seriesline);
				var option = {
					tooltip: {  trigger: 'axis', axisPointer: {  type: 'shadow' } },
					color:this.colors,
					// legend: { icon:"circle",itemGap:20,itemWidth:6, itemHeight:6, textStyle:{color:'#f8f8f'}},
					grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
					xAxis: [  { type: 'category', data:xline , axisTick:{show:false},axisLabel:{interval:0,rotate:40,fontSize: 9,color:'#eee'}} ],
					yAxis: [{type: 'value',splitLine:{show:false},axisTick:{show:false},}],
					series: [ 
						{name:'行业用地面积（亩）',barWidth:20,type: 'bar',stack: 'Ad', emphasis: {focus: 'series'},data: seriesline}, 
					]
				};
				chart.setOption(option);
				var startCharts = null;
				// 2、鼠标移动上去的时候的高亮动画
				chart.on('mouseover', function(param) {
					isSet = false
					clearInterval(startCharts)
					// 取消之前高亮的图形
					chart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					// 高亮当前图形
					chart.dispatchAction({
						type: 'highlight',
						seriesIndex: 0,
						dataIndex: param.dataIndex
					})
					// 显示 tooltip
					chart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						dataIndex: param.dataIndex
					})
				});
				var chartHover = function() {
					var dataLen = option.series[0].data.length
					// 取消之前高亮的图形
					chart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
					// 高亮当前图形
					chart.dispatchAction({
						type: 'highlight',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					// 显示 tooltip
					chart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
				}
				startCharts = setInterval(chartHover, 2000)
				// 4、鼠标移出之后，恢复自动高亮
				chart.on('mouseout', function(param) {
					if (!isSet) {
						startCharts = setInterval(chartHover, 2000)
						isSet = true
					}
				});
			},
			cyyddatabarfunb(el,data){
				var chart = echarts.init(document.getElementById(el));
				var _this = this,xline=[],seriesline=[]; 
				var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				for(var i=0;i<data.length;i++){
					xline.push(data[i].name);
					seriesline.push(data[i].value);
				}
				var option = {
					tooltip: {  trigger: 'axis', axisPointer: {type: 'shadow' },formatter:"{b}:{c}万元/亩"},
					color:this.colors,
					label:{show:true,position: 'top', valueAnimation: true },
					legend: { icon:"circle",itemWidth:6, itemHeight:6, textStyle:{color:'#f8f8f'}},
					grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
					xAxis: [  { type: 'category', data:xline, axisTick:{show:false},axisLabel:{interval:0,rotate:40,fontSize: 9,color:'#eee'}} ],
					yAxis: [{type: 'value',splitLine:{show:false},axisTick:{show:false},}],
					series: [ 
						{barWidth:20,type: 'bar', emphasis: {focus: 'series'},data: seriesline}, 
					]
				};
				chart.setOption(option);
				var startCharts = null;
				// 2、鼠标移动上去的时候的高亮动画
				chart.on('mouseover', function(param) {
					isSet = false
					clearInterval(startCharts)
					// 取消之前高亮的图形
					chart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					// 高亮当前图形
					chart.dispatchAction({
						type: 'highlight',
						seriesIndex: 0,
						dataIndex: param.dataIndex
					})
					// 显示 tooltip
					chart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						dataIndex: param.dataIndex
					})
				});
				var chartHover = function() {
					var dataLen = option.series[0].data.length
					// 取消之前高亮的图形
					chart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
					// 高亮当前图形
					chart.dispatchAction({
						type: 'highlight',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					// 显示 tooltip
					chart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
				}
				startCharts = setInterval(chartHover, 2000)
				// 4、鼠标移出之后，恢复自动高亮
				chart.on('mouseout', function(param) {
					if (!isSet) {
						startCharts = setInterval(chartHover, 2000)
						isSet = true
					}
				});
			},
			cyyddatalinefun(el,data){ 
				var chart = echarts.init(document.getElementById(el));
				var _this = this,xline=[],gkseriesline=[],sfseriesline=[]; 
				for(var i=0;i<data.gk.length;i++){
					xline.push(data.gk[i].name);
					gkseriesline.push(data.gk[i].size);
				}
				for(var j=0;j<data.sf.length;j++){
					sfseriesline.push(data.sf[j].size);
				} 
				var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消 
				var namedata=['工矿用地总成交量（亩）','商服用地总成交量（亩）'];
				var option = {
					tooltip: {  trigger: 'axis', axisPointer: {type: 'shadow' }},
					color:this.colors, 
					legend: {show:true, itemGap:40, textStyle:{color:'#f8f8f'}},
					grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
					xAxis: [  { type: 'category', data:xline, axisTick:{show:false},axisLabel:{interval:0,rotate:40,fontSize: 9,color:'#eee'}} ],
					yAxis: [{type: 'value',splitLine:{show:false},axisTick:{show:false},}],
					series: [ 
						{barWidth:20,name:namedata[0],type: 'line', emphasis: {focus: 'series'},data: gkseriesline}, 
						{barWidth:20,name:namedata[1],type: 'line', emphasis: {focus: 'series'},data: sfseriesline}, 
					]
				};
				chart.setOption(option); 
			}, 
		}
	}
</script>

<style scoped="scoped">
	@import url("../../css/dataswiper.css");
</style>
